import type { IBound } from '@blocksuite/global/utils';

import type { AttachmentChipElementModel } from '../../element-model/attachment-chip.js';
import type { RoughCanvas } from '../../rough/canvas.js';
import type { Renderer } from '../renderer.js';

export function attachmentChip(
  model: AttachmentChipElementModel,
  ctx: CanvasRenderingContext2D,
  matrix: DOMMatrix,
  _renderer: Renderer,
  _rc: RoughCanvas,
  _viewportBound: IBound
) {
  const [, , w, h] = model.deserializedXYWH;
  const cx = w / 2;
  const cy = h / 2;

  ctx.setTransform(
    matrix.translateSelf(cx, cy).rotateSelf(0).translateSelf(-cx, -cy)
  );

  // Background at local origin; world transform is in matrix already
  ctx.fillStyle = model.bg;
  ctx.strokeStyle = model.border;
  ctx.lineWidth = 1;
  const x = 0;
  const y = 0;
  // rounded rect
  const r = Math.min(6, h / 2);
  ctx.beginPath();
  ctx.roundRect(x, y, w, h, r);
  ctx.fill();
  ctx.stroke();

  // Text
  ctx.fillStyle = model.textColor;
  ctx.font = model.kind === 'timestamp'
    ? '400 10px Inter, system-ui, sans-serif'
    : '500 11px Inter, system-ui, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(model.label, x + w / 2, y + h / 2);
}
